<template>
  <div
    class="error-message-backdrop"
  >
    <div class="error-message-container">
      <div class="error-message-item">
        <div class="error-message-text">
          {{ errorMsg }}
        </div>
      </div>
      <div class="error-message-item">
        <SpinnerButton
          class="preview-action-button"
          @click="emitClick"
        >
          Take Me Back
        </SpinnerButton>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import SpinnerButton from '@/components/utilComponents/SpinnerButton.vue';

export default Vue.extend({
  name: 'SetupErrorModal',
  components: {
    SpinnerButton
  },
  props: {
    errorMsg: String
  },
  data: () => ({
    isAddingToPromptPack: false,
    selectedPromptPack: {}
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    emitClick() {
      this.$emit('click');
    }
  },
})
</script>

<style scoped lang="scss">
.error-message-backdrop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.error-message-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 35%;
  border-radius: 0.3em;
  background-color: $baby-blue;
  box-shadow: 0 6px 8px -4px $smoke-gray;
}

.error-message-item {
  flex: 1;
  padding: 1em 1.6em;
  margin: 0 auto;
}

.error-message-text {
  padding: 0.4em 0.8em;
  font-size: 1.1em;
}
</style>